export default __webpack_public_path__ + "static/pokora-6817761d0212f5c1fcd95f21f1b9b140.jpg";